import { Performer, HttpMethod } from '../core'
import type { AuthPayload, AuthResponse } from './models'

export class Login extends Performer<{ payload: AuthPayload }, AuthResponse> {
  protected method = HttpMethod.POST
  protected url = '/login'
}
